import { cx } from "class-variance-authority";
import creditCardType, { types as cardTypes } from "credit-card-type";
import React, { useMemo } from "react";

import { ReactComponent as MasterCardLogo } from "./assets/mastercard.svg";
import { ReactComponent as VisaLogo } from "./assets/visa.svg";
import * as styles from "./Card.module.scss";

const formatCardNumber = (cardNumber: string): string =>
  cardNumber.replace(/(.{4})/g, "$1 ").trim();

type CardProps = {
  className?: string;
  name: string;
  number: string;
  expiry: string;
  isActive?: boolean;
};

const CardIssuerLogoMap: Record<string, React.ReactNode> = {
  mastercard: <MasterCardLogo />,
  visa: <VisaLogo />,
};

const Card = ({
  name,
  number,
  expiry,
  className,
  isActive = false,
}: CardProps) => {
  const { type } = creditCardType(number)[0];

  const formattedCardNumber = useMemo(() => formatCardNumber(number), [number]);
  const logo = CardIssuerLogoMap[type] ?? null;

  return (
    <div
      className={cx(styles.card, className, {
        [styles.active]: isActive,
        [styles.visa]: type === cardTypes.VISA,
        [styles.mastercard]: type === cardTypes.MASTERCARD,
      })}
    >
      <div className={styles.issuer}>{logo}</div>
      <div className={styles.number}>{formattedCardNumber}</div>
      <div className={styles.expiry}>
        <span className={styles.label}>valid thru</span>
        {expiry}
      </div>
      <div className={styles.name}>{name}</div>
    </div>
  );
};

export { Card };
